import { render, staticRenderFns } from "./StoreService.vue?vue&type=template&id=2bae36e0&"
import script from "./StoreService.vue?vue&type=script&lang=js&"
export * from "./StoreService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports